import React from "react";

import { Input } from "../../atoms";
import { Box } from "../../cores";
import { IconSearch } from "../../icons";
import { IKeyStringAndValue } from "../../types/Types";

interface ISearchFilter {
  filter: string;
  setFilterOptions: React.Dispatch<React.SetStateAction<IKeyStringAndValue>>;
  filterOptions: IKeyStringAndValue;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}
export default function SearchFilter({
  filter,
  setFilterOptions,
  filterOptions,
  inputValue,
  setInputValue,
}: ISearchFilter) {

  const handleChange = ((e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setFilterOptions({
      ...filterOptions,
      [filter]: e.target.value,
    });
  })
  
  return (
    <Box>
      <Input
        id="input"
        //@ts-ignore
        postfix={<Input.Icon icon={IconSearch} position={`postfix`} />}
        onChange={handleChange}
        value={Object.keys(filterOptions).length === 0 ? "" : inputValue}
      />
    </Box>
  );
}
